/**
 * Madde API yanıtından ortak yazar id'leri (userIdList) için yardımcılar.
 */

export function parseUserIdsFromUserIdList(userIdList) {
  if (userIdList == null || String(userIdList).trim() === '') return [];
  return String(userIdList).split(',').map((s) => s.trim()).filter(Boolean);
}

/** Tüm maddede geçen tekil kullanıcı id'leri (birincil + userIdList). */
export function collectContributorIdsFromItems(items) {
  const ids = new Set();
  if (!Array.isArray(items)) return ids;
  for (const item of items) {
    if (item.userId != null && item.userId !== '') ids.add(String(item.userId));
    for (const id of parseUserIdsFromUserIdList(item.userIdList)) {
      ids.add(String(id));
    }
  }
  return ids;
}

export function itemInvolvesWriterId(item, userId) {
  const uid = String(userId).trim();
  if (item?.userId != null && String(item.userId) === uid) return true;
  return parseUserIdsFromUserIdList(item?.userIdList).includes(uid);
}

/** Ortak yazar dahil: maddede geçtiği her kayıt tek makale sayılır. */
export function countMakaleForWriterInItems(items, userId) {
  if (!Array.isArray(items) || userId == null || userId === '') return 0;
  return items.filter((item) => itemInvolvesWriterId(item, userId)).length;
}

/**
 * writerName + userIdList ile sıralı yazar satırları (detay / arama kartları için).
 */
export function getAuthorEntriesFromItem(item) {
  const names = (item?.writerName || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
  let ids = [];
  if (item?.userIdList != null && String(item.userIdList).trim() !== '') {
    ids = String(item.userIdList).split(',').map((s) => s.trim()).filter(Boolean);
  } else if (item?.userId != null && item.userId !== '') {
    ids = [String(item.userId)];
  }
  if (names.length === 0 && ids.length === 0) return [];
  if (names.length === 0) {
    return ids.map((userId, i) => ({ name: `Yazar ${i + 1}`, userId }));
  }
  return names.map((name, i) => ({
    name,
    userId: ids[i] != null && ids[i] !== '' ? ids[i] : null
  }));
}
